import Component from 'flarum/common/Component';
import Select from 'flarum/common/components/Select';
import Button from 'flarum/common/components/Button';
import Icon from 'flarum/common/components/Icon';
import app from 'flarum/forum/app';
export default class FeedbackFilters extends Component {
  view() {
    const {
      filter,
      user,
      onFilterChange,
      onGiveFeedback,
      onModerate
    } = this.attrs;
    const allowNegative = app.forum.attribute('huseyinfiliz.traderfeedback.allowNegative') !== false;
    const filterOptions = {
      all: app.translator.trans('huseyinfiliz-traderfeedback.forum.feedback_page.filter.all'),
      positive: app.translator.trans('huseyinfiliz-traderfeedback.forum.feedback_page.filter.positive'),
      neutral: app.translator.trans('huseyinfiliz-traderfeedback.forum.feedback_page.filter.neutral')
    };
    if (allowNegative) {
      filterOptions.negative = app.translator.trans('huseyinfiliz-traderfeedback.forum.feedback_page.filter.negative');
    }
    const actor = app.session.user;
    const canModerate = Boolean(actor && actor.attribute('canModerateFeedback'));
    const pendingFeedbackCount = user && user.attribute('pendingFeedbackCount') || 0;
    const pendingReportCount = user && user.attribute('pendingReportCount') || 0;
    const totalPending = pendingFeedbackCount + pendingReportCount;
    return m("div", {
      className: "TraderFeedbackPage-filters"
    }, m("div", {
      className: "TraderFeedbackPage-filterSelect"
    }, m(Select, {
      value: filter,
      options: filterOptions,
      onchange: onFilterChange
    })), m("div", {
      className: "TraderFeedbackPage-actions"
    }, canModerate && m(Button, {
      className: "Button Button--danger TraderFeedbackPage-modBtn",
      onclick: onModerate
    }, m(Icon, {
      name: "fas fa-gavel",
      className: "TraderFeedbackPage-modBtnIcon"
    }), m("span", {
      className: "TraderFeedbackPage-modBtnText"
    }, app.translator.trans('huseyinfiliz-traderfeedback.forum.moderation.actions_button')), totalPending > 0 && m("span", {
      className: "Button-badge"
    }, totalPending)), app.session.user && user && user.attribute('canGiveFeedback') && m(Button, {
      className: "Button Button--primary TraderFeedbackPage-giveBtn",
      onclick: onGiveFeedback
    }, m(Icon, {
      name: "fas fa-plus",
      className: "TraderFeedbackPage-giveBtnIcon"
    }), m("span", {
      className: "TraderFeedbackPage-giveBtnText"
    }, app.translator.trans('huseyinfiliz-traderfeedback.forum.feedback_page.give_feedback_button')), m("span", {
      className: "TraderFeedbackPage-giveBtnTextShort"
    }, app.translator.trans('huseyinfiliz-traderfeedback.forum.feedback_page.give_feedback_button_short')))));
  }
}
flarum.reg.add('huseyinfiliz-traderfeedback', 'forum/components/TraderFeedback/FeedbackFilters', FeedbackFilters);